import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexBetween, FlexCenter } from '../../global/commonStyle';

interface Props {
  top?: number;
  left?: number;
}

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const InputWrapper = styled.div`
  width: 100%;
  cursor: pointer;
`;

export const IconDiv = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  ${AlignCenter}
  opacity: 1;
  transition: opacity var(--transition-normal);

  ${InputWrapper}:has(input:not(:placeholder-shown)):hover & {
    opacity: 0;
  }
`;

export const ClearIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  ${AlignCenter}
  cursor: pointer;
  opacity: 0;
  transition: opacity var(--transition-normal);

  ${InputWrapper}:has(input:not(:placeholder-shown)):hover & {
    opacity: 1;
  }
`;

export const ErrorText = styled.div`
  color: var(--text-error);
  ${Typography.body_xs}
  margin-top: var(--space-4);
`;

export const CalendarWrapper = styled.div<Props>`
  position: absolute;
  z-index: var(--z-index-toast);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  ${({ top }) => top !== undefined && `top: ${top}px;`}
  ${({ left }) => left !== undefined && `left: ${left}px;`}
  
  .custom-calendar .react-calendar__navigation {
    ${FlexBetween}
    padding-inline: var(--space-8);
    border-bottom: 0.5px solid var(--border-primary);
  }

  .custom-calendar .react-calendar__navigation button {
    background: none;
    border: none;
    padding: var(--space-0);
    margin: var(--space-0);
    cursor: pointer;
    width: 22px;
    height: 40px;
    ${Typography.body_lg_medium}
    color: var(--text-primary);
  }

  .custom-calendar .react-calendar__navigation__label {
    font-weight: 500;
    color: var(--text-primary);
  }

  .react-calendar__viewContainer {
    padding: var(--space-8) var(--space-18);
  }

  .custom-calendar .react-calendar__month-view__weekdays {
    ${Typography.body_lg_medium};
    color: var(--text-secondary);
  }

  .custom-calendar .react-calendar__month-view__weekdays__weekday {
    ${FlexCenter}
    height: 36px;
    width: 36px;
  }
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    gap: var(--space-2);
  }
  .custom-calendar .react-calendar__month-view__days__day {
    height: 24px;
    width: 24px;
    ${FlexCenter}
    color: var(--text-primary);
  }

  .custom-calendar .react-calendar__tile {
    background: none;
    border-radius: var(--border-radius-8);
    transition: background-color var(--transition-normal), color var(--transition-normal);
    border: none;
    margin: var(--space-5);
  }

  .custom-calendar .react-calendar__tile:enabled:hover,
  .custom-calendar .react-calendar__tile:enabled:focus {
    background-color: var(--neutral-secondary);
  }

  .custom-calendar .react-calendar__tile--now {
    background: var(--neutral-secondary);
    color: var(--text-primary);
  }

  .custom-calendar .react-calendar__tile--now:enabled:hover,
  .custom-calendar .react-calendar__tile--now:enabled:focus {
    background: var(--neutral-secondary);
  }

  .custom-calendar .react-calendar__tile--active {
    background: var(--brand-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--active:enabled:hover,
  .custom-calendar .react-calendar__tile--active:enabled:focus {
    background: var(--brand-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--hasActive {
    background: var(--brand-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--hasActive:enabled:hover,
  .custom-calendar .react-calendar__tile--hasActive:enabled:focus {
    background: var(--text-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--other-month {
    color: var(--text-secondary);
  }
  button:disabled {
    color: var(--text-tertiary) !important;
  }
`;

export const Footer = styled.div`
  border-top: 0.5px solid var(--border-primary);
  ${FlexCenter}
  cursor: pointer;
  padding: var(--space-10);
  ${Typography.body_md} p {
    color: var(--text-primary);
    margin: var(--space-0);
  }
`;
